import React, {Component} from 'react';
class LastComments extends Component{
    render(){
        return(
            <div>Úlltimos comentarios</div>
        )
    }
}
export default LastComments


// WEBPACK FOOTER //
// ./resources/assets/js/components/dashboard/LastComments.jsx